<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000341') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" placeholder="시스템선택" style="height: 40px" @change="change">
				<el-option label="ALL" value="ALL"></el-option>
				<el-option :key="index" v-for="(system, index) in systems" :label="system.commCdName" :value="system.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			// console.log('change');
			// console.log(value);
			this.setSearchParam_({ key: 'msgLoc', value: value }).then(() => {
				// serach api call
				// console.log('after action');
				this.$emit('reload', 1, 10);
			});
			// 		value => {

			// 	return setSearchParam_({ key: 'msgLoc', value: value });
			// }
		}
	},
	created() {
		if (this.searchParams.msgLoc == null) {
			this.searchParams.msgLoc = 'ALL';
		}
		this.data = this.searchParams.msgLoc;
	}
};
</script>

<style></style>
